"use client";

import { Download, Rocket } from "lucide-react";

export default function TopBar() {
  return (
    <div className="mb-8 bg-gradient-to-r from-orange-50 to-blue-50 rounded-2xl p-6 sm:p-8 border border-orange-100">
      <div className="flex flex-col lg:flex-row lg:items-start gap-6">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#D67C2C] to-orange-600 flex items-center justify-center shadow-lg shrink-0">
          <Rocket className="w-10 h-10 text-white" />
        </div>
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">ROI Booster</h1>
          <p className="text-gray-600 text-lg">Track collections, expenditure, outstanding dues, and investment return in one clear view.</p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <Feature color="bg-blue-500" text="Monitor cash position" />
            <Feature color="bg-green-500" text="Review income and costs" />
            <Feature color="bg-purple-500" text="Evaluate investment returns" />
          </div>
        </div>
        <div className="flex gap-3 shrink-0">
        <button
          onClick={() => window.print()}
          className="flex items-center gap-2 px-4 py-3 bg-white text-gray-700 border border-gray-200 rounded-xl font-medium hover:bg-gray-50 transition-colors"
        >
          <Download className="w-4 h-4" />
          Print / PDF
        </button>
      </div>
      </div>
    </div>
  );
}

function Feature({ color, text }) {
  return <div className="flex items-center gap-2 text-gray-700"><span className={`w-2 h-2 rounded-full ${color}`} />{text}</div>;
}
